var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7502 24.5844V24.5844C29.7502 25.9018 29.7502 26.5606 29.6054 27.101C29.2124 28.5677 28.0669 29.7132 26.6002 30.1062C26.0598 30.251 25.401 30.251 24.0836 30.251H11.0502C8.67002 30.251 7.47991 30.251 6.57078 29.7878C5.7711 29.3804 5.12093 28.7302 4.71347 27.9305C4.25024 27.0214 4.25024 25.8313 4.25024 23.451V11.551C4.25024 9.17081 4.25024 7.9807 4.71347 7.07158C5.12093 6.27189 5.7711 5.62172 6.57078 5.21426C7.47991 4.75104 8.67002 4.75104 11.0502 4.75104H17.7086",
    stroke: "black",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 11.834V3.33398",
    stroke: "black",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 7.58398H31.1667",
    stroke: "black",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 15.3757C13.6066 15.3757 14.8752 14.1071 14.8752 12.5423C14.8752 10.9775 13.6066 9.70898 12.0418 9.70898C10.477 9.70898 9.2085 10.9775 9.2085 12.5423C9.2085 14.1071 10.477 15.3757 12.0418 15.3757Z",
    stroke: "black",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25262 28.2787L21.2361 17.3847C21.7441 16.9229 21.9981 16.6919 22.2879 16.5978C22.5434 16.5148 22.8172 16.5062 23.0774 16.5729C23.3726 16.6486 23.6406 16.863 24.1768 17.2919L28.1395 20.4621C28.6752 20.8907 28.943 21.1049 29.1456 21.363C29.4002 21.6874 29.5809 22.0634 29.6752 22.4649C29.7502 22.7843 29.7502 23.1273 29.7502 23.8133C29.7502 25.8521 29.7502 26.8715 29.4076 27.6722C28.9777 28.6774 28.1769 29.4781 27.1717 29.9081C26.371 30.2507 25.3516 30.2507 23.3128 30.2507H10.015C9.10406 30.2507 8.6486 30.2507 8.44801 30.0743C8.27414 29.9215 8.18593 29.6933 8.21177 29.4633C8.24158 29.1978 8.57859 28.8915 9.25262 28.2787Z",
    stroke: "black",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/imagePlus.75f3a069ab81d62b791243ab754f0ac5.svg";
export { ForwardRef as ReactComponent };